import React from "react";

export const InputEditor = (props) => {
    const {value, onBlur} = props;

    return (
        <div className="input-editor">
            <input className="panel-input"
                   onBlur={(event) => onBlur(event, value, 'logDecisionValue')}
                   defaultValue={value.logDecisionValue} type="text" placeholder="Condition Name"/>
        </div>
    )
}